var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBelgiumLotto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 40,
    width: 40,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50.4,
    cy: 50,
    r: 48.43,
    fill: "#e5110b"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.75 44.12c2.29-.61 6.81-1.26 10.26.84s3.69 4.9 2.19 7.6c-1.49 2.71-6.35 4.62-9.14 4.62-2.8 0-7.28.14-8.73-3.22s.84-6.35 3.82-7.56c2.99-1.21 4.81-.05 4.81-.05s-.56.42-1.16 1.45c-.61 1.03-1.21 2.28-1.03 3.92.19 1.63 2.24 2.15 3.45.93 1.21-1.21 1.63-3.59.79-5.27s-2.94-2.43-5.27-2.1-4.24 1.35-4.24 1.35c-.32-.5 1.96-1.9 4.25-2.51zm42.48 2.52s1.91-1.03 4.25-1.35c2.33-.33 4.43.42 5.27 2.1s.42 4.06-.79 5.27-3.27.7-3.45-.93c-.19-1.63.42-2.89 1.03-3.92s1.17-1.45 1.17-1.45-1.82-1.17-4.81.05c-2.99 1.21-5.27 4.2-3.83 7.56 1.45 3.36 5.93 3.22 8.73 3.22s7.65-1.91 9.14-4.62c1.49-2.7 1.26-5.5-2.19-7.6s-7.98-1.45-10.26-.84c-2.3.6-4.58 2-4.26 2.51zM23.38 58.58c-.65-.05-1.07-.23-1.63-1.07s-.47-3.92-.33-4.53 2.99-17.96 2.99-17.96h-7.56l-3.29 19.22c-.35 2.94-.02 5.22 1.75 7.79s6.11 2.8 6.11 2.8h10.17l.89-6.25h-9.1zm28.92-.84c-.65-.05-1.25-.19-1.76-1.49-.37-.94.37-4.3.51-4.9.02-.1.11-.62.25-1.42h3.67l1.12-6.41h-3.73l.84-5.14h-7.59L42.9 54.25c-.35 2.94-.02 5.22 1.75 7.79s5.51 2.52 5.51 2.52h4.22l1.31-6.79c-1.67 0-3.13-.01-3.39-.03zm13.41 0c-.65-.05-1.25-.19-1.76-1.49-.37-.94.37-4.3.51-4.9.02-.1.11-.62.25-1.42h3.59l1.12-6.41h-3.65l.84-5.14h-7.59l-2.71 15.87c-.35 2.94-.02 5.22 1.75 7.79s5.51 2.52 5.51 2.52h12.04l1.35-6.81c0-.01-10.59.04-11.25-.01z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBelgiumLotto);
export default __webpack_public_path__ + "static/media/belgium_lotto.9e0784129ab2fe26614b6e5abebb96e7.svg";
export { ForwardRef as ReactComponent };